import { FC, PropsWithChildren } from 'react';
import cls from 'classnames';

import './style.scss';

interface ISkeletonWrapperProps {
  /**
   * true - skeleton will prevent document scroll
   * @default false
   */
  fix?: boolean;
}

/**
 * wrapper for skeleton
 *
 * FIXME: move skeleton-scan-line logic into this component
 */
export const SkeletonWrapper: FC<PropsWithChildren<ISkeletonWrapperProps>> = (props) => {
  const { children, fix = false } = props;
  return <div className={cls('skeleton-wrapper', { fix })}>{children}</div>;
};
